import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function RedirectToHeygenButton() {
  const { t } = useTranslation();
  
  const handleRedirect = () => {
    window.open("https://app.heygen.com/settings?from=&nav=Subscriptions%20%26%20API", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="p-2 rounded-md flex cursor-pointer gap-3 hover:bg-muted" onClick={handleRedirect} title={t("common.heygenSubscription")}>
      {/* <img className="h-6 w-16" src={"https://app.heygen.com/icons/heygen/wordmark/png/heygen_logo_full_black_old_purple.png"} alt={"HeyGen Logo"}/> */}
      <ExternalLink className="h-6 w-6" strokeWidth={1} />
      {t("common.heygen")}
    </div>
  );
}
